<div class="table-page" [class.table-page--fill]="!isCalled" [class.limit-section]="isCalled">
  <header class="header" *ngIf="!isCalled">
    <div class="title-row">
      <ng-container *ngIf="!isCalled">
        <button class="back" type="button" aria-label="بازگشت" routerLink="/">
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
        <div class="title-block"><h1 class="title">تمدید اعتبار خودروها</h1></div>
      </ng-container>
    </div>
  </header>

  <section class="card" aria-label="فهرست تمدید اعتبار خودروها">
    <div class="table-toolbar">
      <div class="search-wrap">
        <input class="control" type="search" aria-label="جستجو در خودروها" [disabled]="loading"
          placeholder="جستجو در جدول: نام راننده، پلاک، شماره تماس، تاریخ اعتبار، حوزه خدمت..."
          [(ngModel)]="searchText" (ngModelChange)="refreshTable(true)" />
        <i class="fa fa-search" aria-hidden="true"></i>
      </div>
      <div class="toolbar-actions">
        <button *ngIf="bSendPush" class="btn btn-primary" type="button" [disabled]="loading || !selectedCount" (click)="openPush_User()">
          <i class="fa fa-envelope-o" aria-hidden="true"></i> ارسال پیام
          <span *ngIf="selectedCount">({{ selectedCount | number | faNum }})</span>
        </button>
        <button class="btn btn-soft" type="button" [disabled]="loading || hasError || !lst_Expired.length" (click)="exportexcel()">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i> خروجی اکسل
        </button>
      </div>
    </div>

    <div class="body" [attr.aria-busy]="loading">
      <div class="loader" [class.show]="loading" role="status" aria-live="polite">
        <div class="spinner"></div><span>در حال دریافت اطلاعات…</span>
      </div>
      <div class="state" id="stEmpty" [class.show]="!loading && !hasError && !lst_Expired.length">
        <div class="ico-big"><i class="fa fa-inbox" aria-hidden="true"></i></div>
        <h4>{{ searchText.trim() ? 'با این فیلترها نتیجه‌ای پیدا نشد!' : 'خودرویی برای تمدید اعتبار وجود ندارد' }}</h4>
        <span class="muted" *ngIf="searchText.trim()">عبارت جستجو را تغییر دهید و دوباره تلاش کنید.</span>
        <div class="empty-actions" *ngIf="searchText.trim()">
          <button class="btn btn-ghost" type="button" (click)="searchText = ''; refreshTable(true)">
            <i class="fa fa-undo" aria-hidden="true"></i> حذف جستجو
          </button>
        </div>
      </div>
      <div class="state error" id="stError" [class.show]="!loading && hasError" role="alert">
        <div class="ico-big"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
        <h4>دریافت اطلاعات با خطا مواجه شد</h4>
        <span class="muted">اتصال به سرور را بررسی و دوباره تلاش کنید.</span>
        <button class="btn btn-primary retry" type="button" (click)="get_ExpiredCars()">
          <i class="fa fa-refresh" aria-hidden="true"></i> تلاش مجدد
        </button>
      </div>

      <div class="table-scroll" id="tableWrap">
        <table aria-label="تمدید اعتبار خودروها">
          <thead id="thead">
            <tr>
              <th class="col-num sticky-first">ردیف</th>
              <th>
                <input type="checkbox" aria-label="انتخاب همه خودروهای نتیجه جستجو"
                  [disabled]="loading || !lst_Expired.length" [checked]="bSelectAll"
                  [indeterminate]="selectedCount > 0 && !bSelectAll" (change)="toggleAll($any($event.target).checked)" />
              </th>
              <th>نام راننده</th>
              <th>پلاک</th>
              <th>شماره راننده</th>
              <th>شماره سیم‌کارت</th>
              <th>تاریخ پایان اعتبار</th>
              <th>حوزه خدمت</th>
            </tr>
          </thead>
          <tbody id="tbody">
            <tr *ngFor="let item of pagedRows; let i = index; trackBy: trackByVehicle" (click)="changeRoute(item)">
              <td class="col-num sticky-first">{{ (currentPage - 1) * pageSize + i + 1 | faNum }}</td>
              <td (click)="$event.stopPropagation()">
                <input type="checkbox" [attr.aria-label]="'انتخاب خودرو ' + item.strVehicleNo" [checked]="item.bChosen"
                  (change)="toggleVehicle(item, $any($event.target).checked)" />
              </td>
              <td><a [routerLink]="['/carInfo', item.strUnitID]" target="_blank" rel="noopener" (click)="$event.stopPropagation()">{{ item.strFullName | faNum }}</a></td>
              <td>{{ item.strVehicleNo | faNum }}</td>
              <td>{{ item.strMobile | faNum }}</td>
              <td>{{ item.strCellNo | faNum }}</td>
              <td>{{ item.strValidDate | faNum }}</td>
              <td>{{ item.strMobileDomain_strComment | faNum }}</td>
            </tr>
          </tbody>
          <tfoot *ngIf="!loading && !hasError && lst_Expired.length">
            <tr>
              <td class="sticky-first"></td>
              <td class="label" colspan="7">تعداد کل: {{ lst_Expired.length | number | faNum }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="lst_Expired.length"
      (pageChange)="changePage($event)" (pageSizeChange)="changePageSize($event)">
    </app-table-pagination>
  </section>
</div>

    <!-- ارسال پوش -->

    <div class="modal fade" id="Push_Modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

        <div class="modal-dialog modal-dialog-centered">

            <div class="modal-content">

                <div class="modal-header">

                    <h5 class="modal-title  ms-0"> ارسال پیام به راننده </h5>

                    <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close"></button>

                </div>

                <div class="modal-body" [formGroup]="mdl_Request">

                    <ng-container *ngIf="mdl_Request.get('iPushType')?.value == 0">

                        <div class="row gx-0 gy-0">

                            <div class="col-12 col-md-6 px-2" (click)="mdl_Request.get('iPushType').setValue('2')">

                                <div
                                    class="pointer bg-success w-100 p-1 py-2 d-flex flex-column justify-content-center align-items-center border border-2">

                                    <span class="text-white"> صدا </span>

                                    <i class="fa fa-microphone fa-lg my-2 text-white" aria-hidden="true"></i>

                                </div>

                            </div>

                            <div class="col-12 col-md-6 px-2" (click)="mdl_Request.get('iPushType').setValue('1')">

                                <div
                                    class="pointer bg-primary  w-100 p-1 py-2 d-flex flex-column justify-content-center align-items-center border border-2">

                                    <span class="text-white"> پیام </span>

                                    <i class="fa fa-envelope-o fa-lg text-white my-2" aria-hidden="true"></i>

                                </div>

                            </div>

                        </div>

                    </ng-container>

                    <!-- متن -->

                    <ng-container *ngIf="mdl_Request.get('iPushType')?.value == 1">

                        <!-- عنوان -->

                        <div class="position-relative col-12 p-2">

                            <label class="mb-2 text-muted" style="top: -5px;"> عنوان </label>

                            <input class="form-control p-2 text-center" formControlName="strTitle">

                        </div>

                        <!-- متن پیام -->

                        <div class="col-12 p-2">

                            <textarea style="height: 120px;resize: none;" formControlName="strMessage" placeholder="متن پیام خود را وارد کنید" class="form-control">

                            </textarea>

                        </div>

                    </ng-container>

                    <!-- صدا -->

                    <ng-container *ngIf="mdl_Request.get('iPushType')?.value == 2">

                        <div class="col-12 p-2">

                            <!-- عنوان -->

                            <div class="position-relative col-12 p-2">

                                <label class="mb-2 text-muted" style="top: -5px;"> عنوان </label>

                                <input class="form-control p-2 text-center" formControlName="strTitle">

                            </div>

                        </div>

                        <div class="col-12 p-2">

                            <!-- start Recording -->

                            <ng-container *ngIf="!isAudioRecording && !isAudioRecorded()">

                                <button class="btn btn-secondary w-100" (click)="startAudioRecording()">

                                    <i class="fa fa-microphone me-1" aria-hidden="true"></i>

                                    <span class="text-warning"> {{ '*' }} </span>

                                    ضبط صدا

                                    <span> {{ '( اجباری )' }} </span>

                                </button>

                            </ng-container>

                            <!-- stop Recording -->

                            <ng-container *ngIf="isAudioRecording && !isAudioRecorded()">

                                <button class="btn btn-secondary w-100" (click)="stopAudioRecording()">

                                    <i class="fa fa-square me-1" aria-hidden="true"></i>

                                    توقف صدا

                                    <span> {{ audioRecordedTime | faNum }} </span>

                                </button>

                            </ng-container>

                            <!-- play Recording -->

                            <ng-container *ngIf="!isAudioRecording && isAudioRecorded()">

                                <div class="position-relative">

                                    <div class="audio-icon col-2" *ngIf="isAudioRecorded()">

                                        <button class="btn" style="background: #F1F3F4;"
                                            (click)="clearAudioRecordedData()">

                                            <i class="fa fa-trash fa-lg" aria-hidden="true"></i>

                                        </button>

                                    </div>

                                    <div *ngIf="audioSrcUrl != ''">

                                        <audio controls class="w-100 rounded">

                                            <source [src]="audioSrcUrl" type="audio/mp3">

                                            Your browser does not support the audio element.

                                        </audio>

                                    </div>

                                </div>

                            </ng-container>

                        </div>

                    </ng-container>

                </div>

                <div class="modal-footer" style="direction: ltr;">

                    <ng-container *ngIf="mdl_Request.get('iPushType')?.value != 0">

                        <button class="btn btn-outline-secondary" (click)="mdl_Request.get('iPushType').setValue('0')">

                            بازگشت

                        </button>

                        <button type="button" class="btn btn-success" (click)="sendPush_4Users()">

                            ارسال پیام

                        </button>

                    </ng-container>

                </div>

            </div>

        </div>

    </div>
